export default {"src":"/_next/static/media/myketSVG.db30ffa2.svg","height":48,"width":48};